export const ProductMenu = {
  routes: [
    {
      name: 'products',
      displayName: 'menu.products',
      subject_class: 'Products',
    },
    {
      name: 'packages',
      displayName: 'menu.packages',
      subject_class: 'Packages',
    },
    {
      name: 'fragilities',
      displayName: 'menu.fragilities',
      subject_class: 'Fragilities',
    },
    {
      name: 'product-lines',
      displayName: 'menu.productLines',
      subject_class: 'ProductLines',
    },
    {
      name: 'product-families',
      displayName: 'menu.productFamilies',
      subject_class: 'ProductFamilies',
    },
    {
      name: 'product_sequence',
      displayName: 'menu.productSequence',
      subject_class: 'ProductSequence',
    },
    {
      name: 'layer-picker',
      displayName: 'menu.layer_picking',
      subject_class: 'LayerPicker',
    },
    {
      name: 'product-groups',
      displayName: 'menu.product_groups',
      subject_class: 'ProductGroups',
    },
    {
      name: 'ignored-products',
      displayName: 'menu.ignored_products',
      subject_class: 'Products',
    },
    {
      name: 'unit-products',
      displayName: 'menu.unit_products',
      subject_class: 'Products',
    },
  ]
} 
